export default __webpack_public_path__ + "static/media/slider-service1.0ca3716c.png";